import React from "react";
import { Publish } from "@material-ui/icons";
import { Championship, Race, RaceResult } from "api";
import Papa from "papaparse";
import { FormButton } from "ui/componentes";

interface UploadRaceResultsProps {
    race: Race;
    uploading?: boolean;
    uploadResults: (
        result: RaceResult[],
        raceId: string,
        championship: Championship
    ) => void;
    championship: Championship;
}

const parseResults = (
    file,
    raceNumber,
    onComplete: (results: RaceResult[]) => void
) => {
    Papa.parse(file, {
        encoding: "ISO-8859-1",
        complete: function (parserResults) {
            const { data } = parserResults;
            const positionByClass = {};
            const results = data.filter((row) => Number.parseInt(row[0]) < 100);
            const classStartPositionByCarNumber = {};

            const resultsByClassName = results.reduce(
                (previousValue, result) => {
                    const className = result[4];
                    const classResults = previousValue[className] || [];
                    classResults.push(result);
                    return { ...previousValue, [className]: classResults };
                },
                {}
            );

            Object.keys(resultsByClassName).forEach((className) => {
                resultsByClassName[className]
                    .sort((r1, r2) => r1[8] - r2[8])
                    .forEach(
                        (result, index) =>
                            (classStartPositionByCarNumber[result[9]] =
                                index + 1)
                    );
            });

            onComplete(
                data
                    .filter((row) => Number.parseInt(row[0]) < 100)
                    .map((row) => {
                        const classPosition =
                            (positionByClass[row[4]] || 0) + 1;
                        positionByClass[row[4]] = classPosition;
                        return {
                            originalPosition: row[0],
                            position: row[0],
                            originalClassPosition: classPosition,
                            classPosition,
                            carID: row[1],
                            carName: row[2],
                            classID: row[3],
                            originalClassName: row[4],
                            className: row[4],
                            teamID: row[5],
                            iRacingId: row[6],
                            driverName: row[7],
                            startPosition: row[8],
                            classStartPosition:
                                classStartPositionByCarNumber[row[9]],
                            gainedPositions:
                                classStartPositionByCarNumber[row[9]] -
                                classPosition,
                            carNumber: row[9],
                            outID: row[10],
                            outName: row[11],
                            interval: row[12],
                            lapsLead: row[13],
                            qualifyTime: row[14],
                            averageLapTime: row[15],
                            fastestLapTime: row[16],
                            fastLap: row[17],
                            lapsComplete: row[18],
                            incidents: row[19],
                            originalPoints: 0,
                            penaltyPoints: 0,
                            bonusPoints: 0,
                            points: 0,
                            raceNumber,
                        };
                    })
            );
        },
    });
};

const UploadRaceResults: React.FC<UploadRaceResultsProps> = ({
    race,
    uploading = false,
    uploadResults,
    championship,
}) => {
    return (
        <div>
            <input
                accept=".csv"
                id={`result_file_${race.raceNumber}`}
                type="file"
                disabled={uploading}
                style={{ display: "none" }}
                onChange={(event) => {
                    parseResults(
                        event.target.files?.[0],
                        race.raceNumber,
                        (results) => {
                            uploadResults(results, race.id, championship);
                        }
                    );
                }}
            />
            <label htmlFor={`result_file_${race.raceNumber}`}>
                <FormButton
                    loading={uploading}
                    component="span"
                    color="primary"
                >
                    <Publish />
                    Carregar resultados
                </FormButton>
            </label>
        </div>
    );
};

export { UploadRaceResults };
